export default __webpack_public_path__ + "static/media/GG_RGB_Teal&Navy.a75e2770.png";